<h2 mat-dialog-title>{{dialogTitle}}</h2>
<mat-divider></mat-divider>
<form [formGroup]="settingsForm" (ngSubmit)="onSubmit()">
  <mat-form-field class="name-field" appearance="fill">
    <mat-label>Name</mat-label>
    <input class="form-control" matInput [(ngModel)]="setting.name" name="name" formControlName="name">
  </mat-form-field>
  <mat-form-field class="value-field" appearance="fill">
    <mat-label>Value</mat-label>
    <input matInput [(ngModel)]="setting.value" name="value" formControlName="value">
  </mat-form-field>
  <div>
    <mat-form-field class="description-field" appearance="fill">
      <mat-label>Description</mat-label>
      <input matInput [(ngModel)]="setting.description" name="description" formControlName="description">
    </mat-form-field>
  </div>

  <div>
  <mat-form-field appearance="fill">
    <mat-label>Language</mat-label>
    <input matInput
           [(ngModel)]="setting.language"
           [matAutocomplete]="langauto" name="language" formControlName="language">
    <mat-autocomplete #langauto="matAutocomplete">
      <mat-option *ngFor="let language of languages" [value]="language">
        {{language}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Version</mat-label>
    <input matInput
           [matAutocomplete]="auto"
           [(ngModel)]="setting.version" name="version" formControlName="version">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let version of versions" [value]="version">
        {{version}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  </div>
 </form>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="onSubmit()" type="submit"  [disabled]="!settingsForm.valid" [mat-dialog-close]="data.setting">Ok</button>
</mat-dialog-actions>
